import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const getPermission = createAsyncThunk('permission/get', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `get_permissions`,
            params: {
                'role_id': id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const masterAction = createAsyncThunk('module/details', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `all_action_by_module`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addPermission = createAsyncThunk('permission/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'permission',
            data: {
                "role_id": data?.values?.role,
                "type_id": data?.values?.type,
                "is_subscription": data?.values?.is_subscription,
                "subscription_id": data?.values?.subscription,
                "permissionAttributes": data?.permission
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const permission = createSlice({
    name: 'permission',
    initialState: {
        getPermission: null,
        masterAction: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(getPermission.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.getPermission = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.getPermission = null
            }
        });

        builder.addCase(masterAction.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.masterAction = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.masterAction = []
            }
        });
    }
})

export default permission.reducer;